import { awsApiInstance } from '../api/aws-api';
import useAuth from '../hooks/auth-hooks';

import { IPostPinPool, IPostPinPoolResponse } from "../models/cardgroup.interface";
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts new Pin Pool data to AWS
 * 
 * @param {IPostPinPool} pinPool the pin pool data
 * 
 * @returns {IPostPinPool} the api response | error
 */
const PostPinPool = async (pinPool: IPostPinPool): Promise<IPostPinPoolResponse> => {
  const { userId } = useAuth()!;
  
  const awsData = {
    wpId: userId,
    ... pinPool
  };

  try {
    const { data } = await awsApiInstance.post(`/card-group/${pinPool.cardGroupId}/pin-pool`, awsData);

    return data;
  } catch (error) {
    handleRouteError(error, 'Error updating pin pool');
    throw(error);
  }
}

export default PostPinPool;